import { render } from "./Message.vue?vue&type=template&id=26becd75&scoped=true&ts=true"
import script from "./Message.ts?vue&type=script&lang=ts"
export * from "./Message.ts?vue&type=script&lang=ts"

import "./Message.scss?vue&type=style&index=0&id=26becd75&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26becd75"]])

export default __exports__